import {css} from '@emotion/react'
import {InputType} from 'module/CustomField/util/CFInputType'
import {CustomFieldTO} from 'generated/JavaTO'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import {CF} from 'module/CustomField/util/CustomField'
import {TextAlign} from 'type/TextAlign'
import {useMemo} from 'react'

const CFInputAlignmentDict: { [i in InputType]?: TextAlign } = {

	[InputType.AlignRight]: TextAlign.right,
	[InputType.Id]: TextAlign.right,
	[InputType.Number]: TextAlign.right,
	[InputType.Integer]: TextAlign.right,

	[InputType.AlignCenter]: TextAlign.center,

}

const cssAlignRight = css`
	justify-content: end;
	text-align: right;
`
const cssAlignCenter = css`
	justify-content: center;
	text-align: center;
`
const cssAlignLeft = css`
	justify-content: start;
	text-align: left;
`

export function getTextAlignCSS(align: TextAlign | undefined) {
	switch (align) {
		case TextAlign.right:
			return cssAlignRight
		case TextAlign.center:
			return cssAlignCenter
		case TextAlign.left:
			return cssAlignLeft
	}
}

export function getCFAttrTextAlign(cfDef: CustomFieldTO): TextAlign | undefined {
	return TextAlign[CF.getCFAttr(cfDef, CFAttrKey.align)?.value?.toLowerCase() as TextAlign]
}

export function getCFAttrTextAlignCSS(cfDef: CustomFieldTO) {
	let align = getCFAttrTextAlign(cfDef)
	if (!align) {
		// fallback to deprecated "style by cfdef input"
		align = CFInputAlignmentDict[cfDef.input as InputType]
	}
	if (align === TextAlign.right) {
		return cssAlignRight
	} else if (align === TextAlign.center) {
		return cssAlignCenter
	} else if (align === TextAlign.left) {
		return cssAlignLeft
	} else {
		return undefined
	}
}

export function useCFAttrTextAlignCSS(cfDef: CustomFieldTO) {
	return useMemo(() => getCFAttrTextAlignCSS(cfDef), [cfDef])
}
